import { CrmTagWrapper } from "./CrmTagStyle";
export const CrmTag = ({ tagname, color, bgColor }) => {
  return (
    <CrmTagWrapper color={color} bgColor={bgColor} className={"col-lg-4"}>
      <h6>{tagname}</h6>
    </CrmTagWrapper>
  );
};
